export default "/fonts/lato-light-webfont.svg?6e99930f359d8fde9ec62fdef2fbd61c";